module.exports = __webpack_public_path__ + "media/images/bilhete_cortado_bottom-5092dd2da9561a68c0cdaed302c54152.svg";